import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { reducer as form } from 'redux-form';
import { reducer as user } from 'modules/user';
import { reducer as shelf } from './shelf/reducer';
import modules from 'modules';

/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default (asyncReducers = {}) => history => combineReducers({
  form,
  shelf,
  router: connectRouter(history),
  ...modules.reducers,
  ...asyncReducers,
});
